<template>
  <div id="app" v-loading="loading">
    <div class="weui-uploader" style="margin-top: 10px;">
    <el-row>
      <el-col :span="24">
        <div style="align:left;color:red;width:100%;">
           1. 请保证资质及证件图清晰可识!(国徽、红章、证照图信息需完整无遮盖.)<br>
           2. 可点击右上角小图标参看示例图

        </div>
      </el-col>
    </el-row>

    <el-collapse style="width: 95%;margin-left:3%;" accordion>
     <el-collapse-item title="门店类资质">
      <div class="weui-flex__item" style="margin-top: 20px;">
      <el-card>
        <div slot="header" style="margin-left:-60%;">营业执照 <span style="color: #dd6161">（必填）</span>
          <el-popover
          ref="popover1"
          placement="top-start"
          title="示例图"
          width="170"
          trigger="hover"
          content="这是一段内容">
          <img src="@/assets/logo10.jpg" style="width: 170px;height: 120px;">
          <i slot="reference" class="el-icon-question" style="cursor: pointer;font-size: 16px;color: gray;"></i>
        </el-popover>
        </div>
        <div style="margin-left: 2px" id="cross">
            <img :src="registeInfo3.shopLicensePicture" class="imgDemo"  @click="choseFile('shopLicensePicture', 'shopLicensePictureServerId')">
        </div>
      </el-card>
     </div>
     <div class="weui-flex__item">
      <el-card>
        <div slot="header" style="margin-left:-50%;">药品经营许可证 <span style="color: #dd6161">（必填）</span>
          <el-popover
          ref="popover1"
          placement="top-start"
          title="示例图"
          width="170"
          trigger="hover"
          content="这是一段内容">
          <img src="@/assets/logo8.jpg" style="width: 170px;height: 120px;">
          <i slot="reference" class="el-icon-question" style="cursor: pointer;font-size: 16px;color: gray;"></i>
        </el-popover>
        </div>
        <div>
          <img :src="registeInfo3.drugBusinessLicensePicture" class="imgDemo"
               @click="choseFile('drugBusinessLicensePicture', 'drugBusinessLicensePictureServerId')">
        </div>
      </el-card>
      </div>
      <div class="weui-flex__item">
      <el-card>
        <div slot="header" style="margin-left:-45%;">二类器械经营备案表 <span style="color: #dd6161">（必填）</span>
          <el-popover
          ref="popover1"
          placement="top-start"
          title="示例图"
          width="170"
          trigger="hover"
          content="这是一段内容">
          <img src="@/assets/logo6.jpg" style="width: 100px;height: 120px;margin-left:30px;">
          <i slot="reference" class="el-icon-question" style="cursor: pointer;font-size: 16px;color: gray;"></i>
        </el-popover>
        </div>
        <div>
          <img :src="registeInfo3.classiiEquipmentRecoedFormPicture" class="imgDemo" @click="choseFile('classiiEquipmentRecoedFormPicture', 'classiiEquipmentRecoedFormPictureServerId')">
        </div>
      </el-card>
      </div>
      <div class="weui-flex__item">
      <el-card>
        <div slot="header" style="margin-left:-40%;">食品经营许可证 <span style="color: #72767b">（没有可不填）</span>
          <el-popover
          ref="popover1"
          placement="top-start"
          title="示例图"
          width="170"
          trigger="hover"
          content="这是一段内容">
          <img src="@/assets/logo7.jpg" style="width: 170px;height: 120px;">
          <i slot="reference" class="el-icon-question" style="cursor: pointer;font-size: 16px;color: gray;"></i>
        </el-popover>
        </div>
        <div>
          <img :src="registeInfo3.foodBusinessLicensePicture" class="imgDemo" @click="choseFile('foodBusinessLicensePicture', 'foodBusinessLicensePictureServerId')">
        </div>
      </el-card>
      </div>
      <div class="weui-flex__item">
      <!--<el-card>
        <div slot="header" style="margin-left:-36%;">药品经营管理规范证书(GSP)
          <el-popover
          ref="popover1"
          placement="top-start"
          title="示例图"
          width="170"
          trigger="hover"
          content="这是一段内容">
          <img src="@/assets/logo5.jpg" style="width: 170px;height: 120px;">
          <i slot="reference" class="el-icon-question" style="cursor: pointer;font-size: 16px;color: gray;"></i>
        </el-popover>
        </div>
        <div>
          <img :src="registeInfo3.drugManagementCertificatePicture" class="imgDemo" @click="choseFile('drugManagementCertificatePicture', 'drugManagementCertificatePictureServerId')">
        </div>
      </el-card>-->
       <div class="weui-flex__item">
      <el-card>
        <div slot="header" style="margin-left:-55%;">药店门脸照片 <span style="color: #dd6161">（必填）</span>
          <el-popover
          ref="popover1"
          placement="top-start"
          title="示例图"
          width="170"
          trigger="hover"
          content="这是一段内容">
          <img src="@/assets/logo11.jpg" style="width: 175px;height: 120px;">
          <i slot="reference" class="el-icon-question" style="cursor: pointer;font-size: 16px;color: gray;"></i>
        </el-popover>
        </div>
        <div>
          <img :src="registeInfo3.shopDoorPicture" class="imgDemo" @click="choseFile('shopDoorPicture', 'shopDoorPictureServerId')">
        </div>
      </el-card>
      </div>
      <div class="weui-flex__item">
      <el-card>
        <div slot="header" style="margin-left:-55%;">店内环境照片 <span style="color: #dd6161">（必填）</span>
          <el-popover
          ref="popover1"
          placement="top-start"
          title="示例图"
          width="170"
          trigger="hover"
          content="这是一段内容">
          <img src="@/assets/logo4.jpg" style="width: 175px;height: 120px;">
          <i slot="reference" class="el-icon-question" style="cursor: pointer;font-size: 16px;color: gray;"></i>
        </el-popover>
        </div>
        <div>
          <img :src="registeInfo3.shopEnvPicture" class="imgDemo" @click="choseFile('shopEnvPicture', 'shopEnvPictureServerId')">
        </div>
      </el-card>
      </div>
      </div>
      <div class="weui-flex__item">
      <!-- <el-card>
        <div slot="header" style="margin-left:-20%;">互联网药品信息服务资格证书 <span style="color: #72767b">（没有可不填）</span>
          <el-popover
          ref="popover1"
          placement="top-start"
          title="示例图"
          width="170"
          trigger="hover"
          content="这是一段内容">
          <img src="@/assets/logo12.png" style="width: 170px;height: 120px;">
          <i slot="reference" class="el-icon-question" style="cursor: pointer;font-size: 16px;color: gray;"></i>
        </el-popover>
        </div>
        <div>
          <img :src="registeInfo3.netDrugServerPicture" class="imgDemo" @click="choseFile('netDrugServerPicture', 'netDrugServerPictureServerId')">
        </div>
      </el-card> -->
      </div>
         </el-collapse-item>
       </el-collapse>
       <el-collapse style="width: 95%;margin-left:3%;" accordion>
         <el-collapse-item title="个人资质类(营业执照上法人或负责人)">
           <div class="weui-flex__item">
      <el-card>
        <div slot="header" style="margin-left:-55%;">身份证正面 <span style="color: #dd6161">（必填）</span>
          <el-popover
          ref="popover1"
          placement="top-start"
          title="示例图"
          width="170"
          trigger="hover"
          content="这是一段内容">
          <img src="@/assets/logo1.jpg" style="width: 180px;height: 100px;">
          <img src="@/assets/logo2.jpg" style="width: 180px;height: 100px;">
          <i slot="reference" class="el-icon-question" style="cursor: pointer;font-size: 16px;color: gray;"></i>
        </el-popover>
        </div>
        <div>
          <img :src="registeInfo3.identityPicture" class="imgDemo" :onerror="logo" @click="choseFile('identityPicture', 'identityPictureServerId')">
        </div>
      </el-card>
      <el-card>
        <div slot="header" style="margin-left:-55%;">身份证反面  <span style="color: #dd6161">（必填）</span>
          <el-popover
          ref="popover1"
          placement="top-start"
          title="示例图"
          width="170"
          trigger="hover"
          content="这是一段内容">
          <img src="@/assets/logo1.jpg" style="width: 180px;height: 100px;">
          <img src="@/assets/logo2.jpg" style="width: 180px;height: 100px;">
          <i slot="reference" class="el-icon-question" style="cursor: pointer;font-size: 16px;color: gray;"></i>
        </el-popover>
        </div>
        <div>
          <img :src="registeInfo3.identityPicture2" class="imgDemo" @click="choseFile('identityPicture2', 'identityPicture2ServerId')">
        </div>
      </el-card>
      </div>
      <div class="weui-flex__item">
      <el-card>
        <div slot="header" style="margin-left:-50%;">手持身份证正面 <span style="color: #dd6161">（必填）</span>
          <el-popover
          ref="popover1"
          placement="top-start"
          title="示例图"
          width="170"
          trigger="hover"
          content="这是一段内容">
          <img src="@/assets/logo3.png" style="width: 160px;height: 120px;">
          <i slot="reference" class="el-icon-question" style="cursor: pointer;font-size: 16px;color: gray;"></i>
        </el-popover>
        </div>
        <div>
          <img :src="registeInfo3.personHandleIdentityPicture" class="imgDemo" @click="choseFile('personHandleIdentityPicture', 'personHandleIdentityPictureServerId')">
        </div>
      </el-card>
      <el-card>
        <div slot="header" style="margin-left:-50%;">手持身份证反面 <span style="color: #dd6161">（必填）</span>
          <el-popover
          ref="popover1"
          placement="top-start"
          title="示例图"
          width="170"
          trigger="hover"
          content="这是一段内容">
          <img src="@/assets/logo3.png" style="width: 160px;height: 120px;">
          <i slot="reference" class="el-icon-question" style="cursor: pointer;font-size: 16px;color: gray;"></i>
        </el-popover>
        </div>
        <div>
          <img :src="registeInfo3.personHandleIdentityPicture2" class="imgDemo" @click="choseFile('personHandleIdentityPicture2', 'personHandleIdentityPicture2ServerId')">
        </div>
      </el-card>
      </div>
         </el-collapse-item>
       </el-collapse>
       <el-collapse style="width: 95%;margin-left:3%;" accordion>
         <el-collapse-item title="药师资质类">
           <div class="weui-flex__item">
        <el-card>
        <div slot="header" style="margin-left:-40%;">执业药师注册证 <span style="color: #dd6161">（必填）</span>
          <el-popover
          ref="popover1"
          placement="top-start"
          title="示例图"
          width="170"
          trigger="hover"
          content="这是一段内容">
          <img src="@/assets/logo13.png" style="width: 170px;height: 150px;">
          <i slot="reference" class="el-icon-question" style="cursor: pointer;font-size: 16px;color: gray;"></i>
        </el-popover>
        </div>
        <div>
          <img :src="registeInfo3.chemistTryPlanPicture" class="imgDemo" @click="choseFile('chemistTryPlanPicture', 'chemistTryPlanServerId')">
        </div>
      </el-card>
      </div>
      <div class="weui-flex__item">
      <el-card>
        <div slot="header" style="margin-left:-40%;">执业药师资格证 <span style="color: #dd6161">（必填）</span>
          <el-popover
          ref="popover1"
          placement="top-start"
          title="示例图"
          width="170"
          trigger="hover"
          content="这是一段内容">
          <img src="@/assets/logo14.png" style="width: 170px;height: 120px;">
          <i slot="reference" class="el-icon-question" style="cursor: pointer;font-size: 16px;color: gray;"></i>
        </el-popover>
        </div>
        <div>
          <img :src="registeInfo3.chemistWorkPicture" class="imgDemo" @click="choseFile('chemistWorkPicture', 'chemistWorkServerId')">
        </div>
      </el-card>
      </div>
         </el-collapse-item>
       </el-collapse>
    </div>
    <el-button @click="btnPrev" class="btnPrev">上一步</el-button>
    <el-button type="success" @click="handleSubmit" class="btnNext">提交</el-button>
  </div>

  <!--<baseInfoRegister @change-step="getPreStepValue"/>-->
</template>

<script>
import {$defalutIcon, choosePic} from '@/commons/wechat'
export default {
  /* eslint-disable */
  props: {
    stepShopId: String,
    required: true
  },
  data () {
    return {
      logo: 'this.src="' + require('@/assets/upload.png') + '"',
      defalutAvater: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAT00lEQVR4Xu1dC7BdVXle/zqBpCmTsYWkCWgLahUJ2hYyBGM4d/97nwskChYdIrVWTVux0KDCFITa4WFbniMoBKv0gY8RGpgWJeEVz9lr3SuBYhO0YKD4GKmtJCXK2GlsSebu9XcWnOtc05yz91rntfbZ/565c5PZ//P79nfXOXuvvRYIPhgBRqAjAsDYMAKMQGcEWCB8dTACXRBggfDlwQiwQPgaYAT8EOARxA839qoIAiyQihDNbfohwALxw429KoIAC6QiRHObfgiwQPxwY6+KIMACqQjR3KYfAiwQP9zYqyIIsEAqQjS36YcAC8QPN/aqCAIskIoQzW36IcAC8cONvSqCAAukIkRzm34IsED8cGOviiDAAqkI0dymHwIsED/c2KsiCLBAKkI0t+mHAAvEDzf2qggCLJCKEM1t+iHAAvHDjb0qggALpCJEc5t+CLBA/HBjr4ogwAKpCNHcph8CLBA/3NirIgiwQCpCNLfphwALxA839qoIAiyQihDNbfohwALxw429KoIAC6QiRHObfgiwQDrglqbppwDgQ36wlsuLiG6O4/jD5ap6ONWyQA6Cs9Z6koi2DoeCMLIAwKlRFH01jGrCqYIFchAulFJPCSHeEA5NQ6nkaUQ8biiZSpSEBXIAWVrr64no4hJx2LdSAeCGKIou6VvAMQjEAplDYpqmEwCgx4BX7xaIKIrjeMo7wJg5skDmEKqU+qYQ4jfGjGPXdv4FEX/T1Wlc7VkgbWaVUn8hhPjYuBLt2NdfIuKfOfqMpTkLRAjRbDbfXKvVHhlLhj2byrJsVaPReNTTfWzcWCBCCK31Y0R00tiw2odGAODrURSt7EOoUoeovEDSNL0cAK4qNYsDKp6Irojj+OMDCl+KsJUWyPT09AlZlu0oBVMjKrJWq51Yr9cfH1H6kaettECUUl8TQqweOQthF/AwIp4SdomDq66yAlFKXSqEuGZw0I5V5MsQ8dqx6qhgM5UUiFLqeCHEkwUxYrOXEXgjIn6ramBUUiBpmrYAIK4a2b30S0RpHMdJLzHK6Fs5gWitLySiG8tI1qhrBoCLoii6adR1DDN/pQTSbDZfV6vVnhkmwOOWK8uy1zcajW+PW1+d+hmIQNI0PVEIcTQALDPGHBEKmFJK++Dr9FDqKWkdDxpjHguldinlj4hoFwB8DxHtXLq+Hn0TyNTU1KuI6JPGmAYALOprlRyMESiGwE+EEFNZll3eaDSeKObS3aovAmk2m5O1Wm2TEOKX+lEUx2AEekGAiP4HAC5BxFt7iWN9exZImqafBoDzei2E/RmBASCwCRHP6SVuTwLRWt9HRGt7KYB9GYFBIkBEN8Rx7P2WpLdAlFJXCCGuHGRzHJsR6AcCxpirkiTxula9BDI9PW3vTm0noiP70QDHYAQGiQAAPCelXFGv13e55vESSKvVulJKaUcQPhiBUiDgO4p4CUQpZd80O7kUyHCRjMDLCHi9a+8sEKXUsUKIpxl1RsADgYeEEHZxuh9KKV8goqOI6FeH9V12ZmbmTZOTk06TVJ0ForU+m4ju8gCHXSqMAABcH0XRRw8GwfT09HFZltlravkgIQKAdVEU3e2Sw0cgPNnPBWG2FUT0RBzHucspKaVokHD5TLZ0Fgjf3h0kheMZ2xhzWpIkuWsdp2l6LgB8doAoXImITusPsEAGyAaHfgmBHYi4oggWSqmjhRDfL2LracMC8QSO3QaEAADcFkXRB4uGV0p9VwjxmqL2jnYsEEfA2HzACLBABgwwhy89AvwRq/QUcgMDRYC/pA8UXg5edgRCuc1rH0jyXayyX01jWn8IDwpZICW9uIjIAMAuItptWwCApUS0DABkSVvqVPZIp5qwQMK/mjQAbM2ybLeU0gpilzFmd6PR+M+Dld5sNn9FSrm0vfjFslqtZoVj1/NqhN9qkBXyR6yQaAGA/caYppTyPinl3fV6fU8/6nvkkUd+ed++fWsA4EwiersQYn4/4lYgBgskBJIB4A67L4+Ucku/RNGpr1mxCCHWCCF+N4T+A66BBTJKcojoTiLamCTJSHararVaqwBgAwD8zihxCDg3C2RE5DwAALdEUfTAiPL/XFqt9RoiuqA9qoRQUig1sECGyQQA2JFiYxRFdw4zb9FcWms7kmwgolVFfcbcjgUyRIIvRcTrhpjPO5VSyu5Y++feAcbHkQUyDC6llO+amJgo1VuVSqkNQohbhoFPwDlYIIMkh4j2SylXR1H0z/3Ko5R6hV3oe86PDf3s7A8i2vVm+3KkafpOAPh7IcS8vgQsXxAWyKA4I6IfvPjiiyvWrl3b07OMVqt1qpTyrPaqMFYYViDdDisQK5iHhRB2KU372/tov5RkBR7Mqvvezbg7skDcMSvk8Rgiei9zpJR6mxBi9ueoQhk7G1mx/IMxZmuR11g7hdFaP0FEb+yxlrK5s0AGwNiziHiMT9z2O9bnCiHsfimDOHYQ0W1xHN/mE1xr/TgR/ZaPb0l9WCB9Ju4niOi8pcMQhHFgm95CUUrZ5TiX9hm3UMOxQPrJjOtCY0qpdwkhLh7giJHX3g4p5Y0TExN2qkuhw258ZIz5QSHj8huxQPrI4XpE/FzReFrr9UT0d0XtB2kHAB+LoujqojlarVZdSjlV1L7EdiyQPpF3ISJ+smgspdQf2yfqRe2HYUdEfx3Hsf3+U+hQSr1PCFH4D0KhoOEZsUB65cR1FXCllBWGFUiIx2ZEPLNoYRVYtZ8FUvRi6GD3vSzLVjYajR8XiaO1brVfYCpiPhIb+4JWFEWnFUnebDYPr9VqdgfbQa1LVaSMQdqwQHpEt/BHK6XUPwoh7AO/MhzXIeKlRQpVSn1ECHFTEdsS2rBAfEkjoscBYCUizuTFSNP0ZgCw08lLcxhjzk+S5K/yClZKzSOixwDghDzbEp5ngfiSZoz5/SRJbs/z11pfRESfyLML8byU8n0TExNfyKut1Wqtl1IGcUcur1bH8ywQR8BeMgeANIqiJM+3PWVkc55d4OfPQMQteTWW4ftVXg8HOc8C8QDNCuQdURTdk+ertb6XiM7Iswv5PABsjqIo986W1vosIrLfs8bpYIF4sFloIuKYjB6z8BQaRdI03Q4Ag5pH5kFVzy4sEFcIiz73GIfRYxaboqOIUuoaIUShu1+uuI/IngXiCjwRnRzHsb333/EYs9Gj8CiilIqEEMoV04DtWSAu5ADAU1EU5W4cOU6jh8co8h0hxGtdcA3YlgXiQg4RXRPH8Z928xnn2a5Zlr2+0Wh8u1v/aZreCgDnu+AasC0LxIWcgh+v3i+EyH0+4pI3FFsiuiSO4xtyPl6O08csFojDxbcbEZfl2Sul7OolZ+fZlfT8FCJaAXQ9lFLPCyEW59mV4DwLxIGkLYjY9ZnG5s2bFx522GE/dYhZOtNDDjnkqNWrVz+XM4rYh6P2nfqyHyyQogwWeV9Ca302EZVq/aui/c+x24CIt+Z8D7kNAD7gETs0FxZIUUYA4ONRFF2R85fTvjT14aIxS2r3GUQ8r1vtWuuriOjykvY3t2wWSFES7Z2ZKIq6zm7VWn+FiHKnZRTNGajdg4hot07oeGitzyOiTwdav0tZLBAHtM5CxC/njCBPCiGOd4hZRtN/RcQ35ODw20KI3LlqJWieBeJA0psR8Z9yLoy9QohfdIhZRtMXEfEXcnCwi+Y9WsbmDqiZBVKURGPM0UmS/Fsn+23bti3Zv3//QfcOLJqjRHbLEPGlDUQPdrRarV+TUtoVHct+sECKMrhkyZL5y5cv39/JPk3TlQDQdYQpmqsEdl1H0507dx76/PPP7ytBH3klDl4g47LyRZZlR3RbnEEpdawQ4uk8xMfhPBEdG8fxM516aS/m8KOy91p05vbcPsG16XERCBEdH8fxzk79K6UWCCH+1xWfMtrv2bNn/rp167qNpssB4Ftl7G1uzSwQNwYnEbHZzaUi69b+ByK+KgcHuy/7V93gDc+aBeLAiTHmvUmSfDHnwrB3bry3PXAoZ5SmX0PEercCWq3W70kpcxd7GGUTRXKzQIqg1LYBgEuiKMqbyWo35zzHIWzpTInoC3Ec22VHOx5a64uJ6PrSNXdAwSwQBwaJ6KY4ji/KGUHG7ZXT/9dukYsmTdMbAeBCB3iDNC3S64GFV/ZLOgDcGUXRu7sx2Ww2T6nVatNBst2noowxJyZJ8njOCHIHEdktpUt9sEDc6NOIiHkuSim7d0bXL7F5MQI+/11E/PW8+pRS9r303PdG8uKM+jwLxJGB+fPnH75q1aoXcv56XmffvHMMXQpzIroljuMPdSt2enp6cZZl9oWp0h8sEHcK34+In8+5QJIsy7reDnZPG4zHGkR8MOcPxPlE1PV9kWC6ySmEBeLO1D2I+I48N631M0T0ujy7kp0v9PEqTdOHAODUkvV20HJZII4sEpFZsGDB4ryPWeMye2AuPEUuFvvxyhizm4ikI7RBmhfp+cDCK3sXaw4Q70HEL+V8zFpmjNlOREcGybxjUQDwnJRyRb1etzvcdjy01h+w20w7hg/WnAXiR82XEPE9ea5jNooUmtWqtd5EROvysCnLeRaIB1NE9AIRvSlJkh9WYRQpOnq0Wq2jpJT2jUrnfeI9aBiKCwvEH+ZrEfGyPPdxGEWKXiRjuHC1KNr73OuAv4O8jMbeWq22sl6vP9VNJO3tyexdnThPTIGe/8qePXveuW7duixntDwuyzK7oPdhgfbhVRYLxAu2nznlLn9jLcu6EywAfH3evHmN1atX/3ceTEopu9rLH+XZle08C6RHxowxb0mS5JG8MK1W6zVSSvsGXi3PNpDzM1mWvbLRaOS+Y99qtVZJKbcFUndfy2CB9AgnEd0Zx3HXCYyzKaanp0/IsmxHjymH4i6lfPXExMT3iyRL0/QOACj9xMSD9coCKXIF5NgAwNooih4oEqoMf22NMRNJkhSakay1XkNE9xfpvYw2LJD+sPZNIYRdVK7QMjd2SZxarfYNIgrtduhPa7Xaqnq9/kQRWO6///7FCxcu3EJEJxWxL6MNC6R/rBWaCj+bTil1BADYh2qh3N3aaYx5a7d1vw6EKk3TTQAwNg8F+SNW/8TQKdKXEfGsomm2b9++cO/evV8kotzJj0Vj+tjZj0iLFi1694oVK/6rqL9S6lohxEeL2pfVjkeQ/jP3OURc7xI2TdNzAeBcIcSwt0/eYedNxXHsNHdKa30BEd3s0mNZbVkgg2HuAkTc6Bp6iELxEobtpyL7n/yMOhaI61Vc0J6IGnEctwqa/5xZWyh2dfSuWwx4xL6PiO51HTFm80xNTZ1qjHnII29pXVggg6Uud1p8t/RKqVcCwBlEZLd98xILEW0FgLtnZma2Tk5O2nflvQ6t9WVEdLWXc4mdWCCDJ+9PEPETvaa56667Dl28eHEMAMcQ0auFEMe0/32MEMLOj7O3mGd/7Ar09t8PI2LP6+MqpexiebnT+3vtMUR/FshwWPkUIn5kOKn6m0UpNS6bcXoBwwLxgs3dyX72r9VqGyYmJv7d3Xv4Hkqp17b3el89/OzhZGSBDJeLJ40xNyVJcvtw07pla7Va66WUdgXJcd9KLhcYFkguRP03AIBUCLExiqKg9vDTWtuHnBsCerrff/AdI7JAHAHrs/k9xpiNSZJYwYzsaLVasZRyg51PNrIiAk3MAgmAGAC43Rjz2TiO7Rt5QzvslnFSyg8SkdOT/6EVGEAiFkgAJMwpwc4Ktisy3oeIehCltfdRPL39XGXlIHKMU0wWSLhsPmsnEdqHfL2KJU3Tt0gp305E9ul87sLT4UIy/MpYIMPH3DkjEe0HALtgm/2xqxbuklLuyrJst/1tAxpjltVqtaX2NwAsE0IsFUIsIyL7/0Odk7LDSwiwQPhCYAS6IMAC4cuDEWCB8DXACPghwCOIH27sVREEWCAVIZrb9EOABeKHG3tVBAEWSEWI5jb9EGCB+OHGXhVBgAVSEaK5TT8EhiIQpdQfCCH+xq9E9mIERorAHyLi37pU4Lw/SJqmpwFA162DXQpgW0ZgWAgQ0elxHDut5OIskPaCA3bVvgXDaozzMAJ9QGDfkiVLFi1fvny/SyxngdjgaZp+HgDe65KIbRmBESOwCRHPca3BSyBKqbcJIewKGXwwAmVB4AxE3OJarJdAbBKt9b3tRdBcc7I9IzBUBABgcxRFZ/ok9RaIUsouIWPfmJvvk5h9GIEhIWD3STkpb4PWTrV4C8QGVEpF9teQGuU0jIAzArVabbmvOGyyngTSFskrhBD3CiFOca6eHRiBASEAAI8aY9bHcWw3W/U+ehbIbOaqLojsjTw7DgqBvQBwdRRF1/QjQd8EYotpP0Q8GQDs5jFHE9GRQojD+1Eox2AEOiDwYwB4zhjzHQBQMzMz2yYnJ7/RL7T6KpB+FcVxGIFQEGCBhMIE1xEkAiyQIGnhokJBgAUSChNcR5AIsECCpIWLCgUBFkgoTHAdQSLAAgmSFi4qFARYIKEwwXUEiQALJEhauKhQEGCBhMIE1xEkAiyQIGnhokJBgAUSChNcR5AIsECCpIWLCgUBFkgoTHAdQSLAAgmSFi4qFARYIKEwwXUEiQALJEhauKhQEGCBhMIE1xEkAiyQIGnhokJBgAUSChNcR5AIsECCpIWLCgUBFkgoTHAdQSLAAgmSFi4qFARYIKEwwXUEiQALJEhauKhQEGCBhMIE1xEkAiyQIGnhokJBgAUSChNcR5AIsECCpIWLCgUBFkgoTHAdQSLAAgmSFi4qFARYIKEwwXUEiQALJEhauKhQEPg/1GRgQWv8ZwkAAAAASUVORK5CYII=',
      registeInfo2: {
        shopLicensePictureServerId: '',
        foodBusinessLicensePictureServerId: '',
        classiiEquipmentRecoedFormPictureServerId: '',
        drugManagementCertificatePictureServerId:'',
        drugBusinessLicensePictureServerId: '',
        identityPictureServerId: '',
        identityPicture2ServerId: '',
        personHandleIdentityPictureServerId: '',
        personHandleIdentityPicture2ServerId: '',
        shopDoorPictureServerId: '',
        shopEnvPictureServerId: '',
        // netDrugServerPictureServerId: '',
        chemistTryPlanServerId: '',
        chemistWorkServerId: '',
        id: '',//shopId
        salesmanPhone: '', //业务员手机号
        buildStep: 1
      },
      registeInfo3:{
        shopLicensePicture: $defalutIcon, // 营业执照
        foodBusinessLicensePicture: $defalutIcon, // 食品安全
        classiiEquipmentRecoedFormPicture: $defalutIcon, // 二类器械
        drugManagementCertificatePicture: $defalutIcon, // 药品经营管理规范
        drugBusinessLicensePicture: $defalutIcon, // 药品经营许可证
        identityPicture: $defalutIcon, // 身份证正面
        identityPicture2: $defalutIcon, // 身份证反面
        personHandleIdentityPicture: $defalutIcon, // 手持身份证正面
        personHandleIdentityPicture2: $defalutIcon, // 手持身份证反面
        shopDoorPicture: $defalutIcon, // 门脸照片
        shopEnvPicture: $defalutIcon, // 门店环境
        // netDrugServerPicture: $defalutIcon, // 互联网资质
        chemistTryPlanPicture: $defalutIcon, // 平台药师审方资格证
        chemistWorkPicture: $defalutIcon // 执业药师资质
      },
      loading: false
    }
  },
  methods: {
    handleSubmit () {
      this.loading = true
      if(this.registeInfo2.shopLicensePictureServerId == null) {
        this.$message.error('营业执照必传')
        this.loading = false
      } else if(this.registeInfo2.drugBusinessLicensePictureServerId == null) {
        this.$message.error('药品经营许可证必传')
        this.loading = false
      } else if(this.registeInfo2.classiiEquipmentRecoedFormPictureServerId == null) {
        this.$message.error('二类器械经营备案必传')
        this.loading = false
      } else if(this.registeInfo2.shopDoorPictureServerId == null) {
        this.$message.error('药店门脸照片必传')
        this.loading = false
      } else if(this.registeInfo2.shopEnvPictureServerId == null) {
        this.$message.error('店内环境照片必传')
        this.loading = false
      } else if(this.registeInfo2.identityPictureServerId == null) {
        this.$message.error('身份证正面必传')
        this.loading = false
      } else if(this.registeInfo2.identityPicture2ServerId == null) {
        this.$message.error('身份证反面必传')
        this.loading = false
      } else if(this.registeInfo2.personHandleIdentityPictureServerId == null) {
        this.$message.error('手持身份证正面必传')
        this.loading = false
      } else if(this.registeInfo2.personHandleIdentityPicture2ServerId == null) {
        this.$message.error('手持身份证反面必传')
        this.loading = false
      } else if(this.registeInfo2.chemistTryPlanServerId == null) {
        this.$message.error('执业药师注册证必传')
        this.loading = false
      } else if(this.registeInfo2.chemistWorkServerId == null) {
        this.$message.error('执业药师资格证必传')
        this.loading = false
      } else {
        this.handleSubmitHandle()
        this.loading = false
      }
    },
    handleSubmitHandle () {
      this.$axios({
        method: 'post',
        url: 'v1/wShopRegister/saveShopInfo',
        data: this.registeInfo2
      }).then((response) => {
        if(response.data.code === 200) {
          this.$emit('change-step', 3, response.data.data.id)
        }
      }).catch((error) => {
        console.log(error);
        this.$message.error("服务异常")
      })
    },
    btnPrev () {
      this.$emit('change-step', 1)
    },
    // getPreStepValue(value){
    //   console.log(value)
    // },
    choseFile(picUrl,serverId){
       this.$weChat.choosePic(this,picUrl,serverId)
    },
      getBaseInfo () {
      this.$axios({
        method: 'get',
        url: '/v1/wShopRegister/getShopInfo?id=' + this.stepShopId,
      }).then((response) => {
        if (response.data.code === 200){
          if (response.data.data != null){
            for(let key in this.registeInfo2){
              this.registeInfo2[key] = response.data.data[key]
              if (key === 'buildStep'){
                this.registeInfo2[key] = 1
              }
            }
            for(let key in this.registeInfo3){
              try {
                let fileName = response.data.data[key]
                this.registeInfo3[key] = fileName
              } catch (e) {
                console.log(e);
              }
            }
          }
        }
      }).catch((error) => {
        console.log('保存失败', '保存失败')
      })
    },
  },

  mounted() {
    let user = this.$storage.fetchStorage("user")
    if (user!=null){
      this.registeInfo2.salesmanPhone = user.salesmanPhone
    }
    let shopId = this.$route.params.id
    if (shopId!=null&&shopId!=''&&shopId!=0){
      this.registeInfo2.id = shopId
    }else{
      this.registeInfo2.id = this.stepShopId
    }
    this.getBaseInfo()
  },
  components: {
  }
}
</script>

<style>
@import url("https://cdn.bootcss.com/weui/1.1.3/style/weui.min.css");
@import url("https://cdn.bootcss.com/jquery-weui/1.2.1/css/jquery-weui.min.css");
#app{
  height: 100%;
}
.registeInfo{
  margin-left: 15px;
}
.btnNext{
  width: 30%;
  margin-top: 20px;
}
.btnPrev{
  width: 30%;
}
.imgDemo{
  width: 60px;
  height: 60px;
  margin-bottom: 20px;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/views/storeRegister/credInfoRegister.vue